import { render, staticRenderFns } from "./fetch-more.vue?vue&type=template&id=5da7688e&"
import script from "./fetch-more.vue?vue&type=script&lang=js&"
export * from "./fetch-more.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports